import { useNavigate } from "react-router-dom";

import ChevronLeft from "atoms/icon/icons/chevron_left.svg";
import TopNav from "molecules/navbars/TopNav";

type AgelessPageShellProps = {
  title: string;
  children: React.ReactNode;
  onBack?: () => void;
};

export function AgelessPageShell({ title, children, onBack }: Readonly<AgelessPageShellProps>) {
  const navigate = useNavigate();

  return (
    <div className="relative flex h-full flex-col bg-one">
      <TopNav
        startIconSVG={ChevronLeft}
        onStartIconClick={onBack ?? (() => navigate(-1))}
        showHeaderItems={false}
      >
        <div className="flex max-h-[32px] items-center">
          <div className="flex w-full items-center justify-center text-sub2 text-primary">
            {title}
          </div>
        </div>
      </TopNav>
      {children}
    </div>
  );
}
